<template>
    <li :class="classes" class="p-2">
        <div class="bg-white relative h-full w-full shadow hover:shadow-md">
            <span v-if="course.city" class="bg-green-500 text-white text-sm py-1 px-2 absolute bottom-0 right-0 rounded-tl">
                {{ course.city }}
            </span>
            <div class="w-full relative h-24 overflow-hidden">
                <img
                    v-if="course.image"
                    :src="`${course.image}?scale=both&width=640&height=390&mode=crop&anchor=middlecenter`"
                    :alt="course.heading"
                />
                <div class="bg-gray-800 bg-opacity-90 text-white text-center absolute top-0 right-0 h-full flex flex-col justify-center items-center w-16">
                    <div class="uppercase text-xs" v-text="getDay(course.start)"></div>
                    <div class="text-4xl font-light" v-text="getDate(course.start)"></div>
                    <div class="uppercase text-xs" v-text="getMonth(course.start)"></div>
                </div>
            </div>
            <div
                class="p-2"
                :class="course.venue ? 'pb-7' : ''"
            >
                <h3 v-if="course.heading" class="text-gray-800 text-lg leading-tight mb-2">
                    {{ course.heading }}
                </h3>
                <p v-if="course.arrangeBy" class="text-gray-600 text-xs mb-2">
                    {{ course.arrangeBy }}
                </p>
                <p v-if="course.description" class="text-gray-800 text-xs mb-0">
                    {{ course.description }}
                </p>
            </div>
            <a :href="course.url" :title="course.heading" class="absolute top-0 left-0 w-full h-full">
                <span class="sr-only">
                    {{ course.heading }}
                </span>
            </a>
        </div>
    </li>
</template>

<script>
export default {
    props: ['course','classes'],
    methods: {
        getDay(date) {
            const days = ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'];
            const d = new Date(date);
            return days[d.getDay()];
        },
        getDate(date) {
            const d = new Date(date);
            return d.getDate();
        },
        getMonth(date) {
            const months = ['jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'];
            const d = new Date(date);
            return months[d.getMonth()];
        }
    }
};
</script>
